import BaseError from '@whr/core_utils/baseError.js';
export var ConfigurationNotSetErrorCode;
(function (ConfigurationNotSetErrorCode) {
    ConfigurationNotSetErrorCode["CONFIGURATION_NOT_SET_ERROR"] = "CONFIGURATION_NOT_SET_ERROR";
    ConfigurationNotSetErrorCode["CONFIGURATION_CANNOT_BE_SET"] = "CONFIGURATION_CANNOT_BE_SET";
})(ConfigurationNotSetErrorCode || (ConfigurationNotSetErrorCode = {}));
export class ConfigurationNotSetError extends BaseError {
    constructor(code, message, originalError) {
        super(code, message, originalError, 500);
    }
}
//# sourceMappingURL=configuration_not_set_error.js.map